import moment from "moment";
import LabServiceModel from "@/models/LabServiceModel";
import SubmissionModel from "@/models/lab/SubmissionModel";
import SampleStatusLogModel from "./SampleStatusLogModel";
import SampleStatusCollection from "@/collections/lab/SampleStatusCollection";
import SampleStatusLogCollection from "@/collections/lab/SampleStatusLogCollection";
import SampleTestPackageCollection from "@/collections/lab/SampleTestPackageCollection";
import AnalysisCollection from "@/collections/lab/AnalysisCollection";
import AnalyteCollection from "@/collections/lab/AnalyteCollection";

export default class SampleModel extends LabServiceModel {
  modelName() {
    return "sample";
  }
  icon() {
    return "sack";
  }
  defaults() {
    return {
      id: null,
      pid: null,
      submission_id: null,
      submission: null,
      number: null,
      abbrev: null,
      identifier: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      sample_septic: null,
      sample_soil: null,
      sample_feed: null,
      sample_status_logs: [],
      current_sample_status_log: null,

      attribute_1: null,
      attribute_2: null,
      attribute_3: null,
    };
  }
  mutations() {
    return {
      id: (val) => this.nullStringMutator(val),
      pid: (val) => this.nullStringMutator(val),
      submission_id: (val) => this.nullStringMutator(val),
      submission: (val) => this.nullObjectMutator(val),
      number: (val) => this.nullStringMutator(val),
      abbrev: (val) => this.nullStringMutator(val),
      identifier: (val) => this.nullStringMutator(val),
      created_at: (val) => this.nullStringMutator(val),
      updated_at: (val) => this.nullStringMutator(val),
      deleted_at: (val) => this.nullStringMutator(val),
    };
  }
  validation() {
    return {};
  }
  getSubmission() {
    return this.getRelatedModel(SubmissionModel, "submission");
  }
  getSampleStatusLogs() {
    return this.getRelatedCollection(
      new SampleStatusLogCollection(),
      "sample_status_logs"
    );
  }
  getCurrentSampleStatusLog() {
    return this.getRelatedModel(
      SampleStatusLogModel,
      "current_sample_status_log"
    );
  }
  getSampleTestPackages() {
    return this.getRelatedCollection(
      new SampleTestPackageCollection(),
      "sample_test_packages"
    );
  }
  publicNumber() {
    return this.get("pid").padStart(6, "0");
  }

  updateStatus(status) {
    return new Promise((resolve, reject) => {
      const statuses = new SampleStatusCollection();

      statuses.getFilter().filterEquals("status", status);
      statuses
        .fetch()
        .then(() => {
          const dt = require("moment")().format("YYYY-MM-DD HH:mm:ss");
          const log = new SampleStatusLogModel({
            sample_id: this.get("id"),
            sample_status_id: statuses.models[0].id,
            start_date: dt,
          });

          log
            .save()
            .then(() => {
              resolve(log);
            })
            .catch(reject);
        })
        .catch(reject);
    });
  }
  updateStatusBatch(status, batch) {
    return new Promise((resolve, reject) => {
      const statuses = new SampleStatusCollection();

      statuses.getFilter().filterEquals("status", status);
      statuses
        .fetch()
        .then(() => {
          const dt = require("moment")().format("YYYY-MM-DD HH:mm:ss")
          
          // format the batch payload to add the status id
          batch = batch.map((el) => {
            return {
              ...el,
              sample_status_id: statuses.models[0].id,
              start_date: dt,
            }
          });

          const log = new SampleStatusLogModel()
            .batchReceive(batch)
            .then((res) => resolve(res))
            .catch(reject);
        })
        .catch(reject)
    })
  }
  setStatus(name) {
    return new Promise((resolve, reject) => {
      const statuses = new SampleStatusCollection();

      statuses.getFilter().filterEquals("status", name);

      return statuses.fetch().then(
        () => {
          const status = statuses.first();

          if (!status) {
            return reject(`${name} sample status could not be found`);
          }

          const currentStatus = this.getCurrentSampleStatusLog();

          if (currentStatus.id === status.id) {
            return reject(`${name} sample status is already set`);
          }

          const log = new SampleStatusLogModel({
            sample_id: this.id,
            sample_status_id: status.id,
            start_date: moment().format("YYYY-MM-DD HH:mm:ss"),
          });

          return log.save().then(
            () => {
              return resolve(log);
            },
            () => {
              return reject(`${name} sample status could not be set`);
            }
          );
        },
        () => {
          return reject(`${name} sample status could not be found`);
        }
      );
    });
  }
  getAnalytes() {
    const analytes = new AnalyteCollection();

    if (this.id) {
      const exists = [];
      const stp_collection = this.getSampleTestPackages();

      stp_collection.each((stp) => {
        const tps = stp.getTestPackageSample();

        if (tps) {
          const tps_analytes = tps.getAnalytes();

          if (tps_analytes) {
            tps_analytes.each((analyte) => {
              if (exists.includes(analyte.id)) {
                return;
              }
              analytes.add(analyte);
              exists.push(analyte.id);
            });
          }
        }
      });
    }

    return analytes;
  }

  getAnalyses() {
    const analyses = new AnalysisCollection();

    if (this.id) {
      const exists = [];
      const analytes = this.getAnalytes();

      analytes.each((analyte) => {
        let analyte_analyses = analyte.getAnalyses();
        if (analyte_analyses) {
          analyte_analyses.each((analysis) => {
            if (exists.includes(analysis.id)) {
              return;
            }
            analyses.add(analysis);
            exists.push(analysis.id);
          });
        }
      });
    }

    return analyses;
  }
}
